import { SVGWrapper } from '../SVGWrapper';

const KubernetesWorkloadIcon = SVGWrapper(() => {
  return (
    <svg
      width="64px"
      height="64px"
      viewBox="0 0 20 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      stroke="#9333ea"
      strokeWidth={0.8}
      strokeLinecap="round"
      strokeLinejoin="round">
      <title>Kubernetes Workload</title>
      <polygon points="9.3,7 7.85,9.51 4.95,9.51 3.5,7 4.95,4.49 7.85,4.49" />
      <polygon points="16.5,7 15.05,9.51 12.15,9.51 10.7,7 12.15,4.49 15.05,4.49" />
      <polygon points="12.9,13.6 11.45,16.11 8.55,16.11 7.1,13.6 8.55,11.09 11.45,11.09" />
      <circle cx="6.4" cy="7" r="0.65" />
      <circle cx="13.6" cy="7" r="0.65" />
      <circle cx="10" cy="13.6" r="0.65" />
    </svg>
  );
});

export default KubernetesWorkloadIcon;
